export const PASSPORT_MESSAGE = "No file chosen";

export const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const IDENTITY_VERIFICATION_INSTRUCTIONS =
  "Vous devrez présenter une pièce d'identité à votre arrivée ou l’envoyer maintenant.";

export const IDENTITY_VERIFICATION_MESSAGE =
  "Vous devrez présenter une pièce d'identité à votre arrivée.";
